import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import App from "App";
import { sentryInit } from "JS/Helpers/SentryHelper";
import { migrateExistingValues } from "JS/Helpers/LocalStorageHelpers";
import { initializeConfigTokens } from "JS/Config";
import { appConstants } from "JS/Helpers/Constants";
import "./fonts.css";

sentryInit();
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

async function initializeApp() {
    try {
        await migrateExistingValues();
        await initializeConfigTokens();
    } catch (e) {
        console.error("Token initialization failed, clearing corrupt tokens:", e);
        localStorage.removeItem(appConstants.localStorage.courseFirebaseToken);
        localStorage.removeItem(appConstants.localStorage.webcastsFirebaseToken);
        localStorage.removeItem(appConstants.localStorage.aesGcmMigrated);
    }
    ReactDOM.render(<App />, document.getElementById("root"));
}

initializeApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorkerRegistration.register();

reportWebVitals();
